const Parse = require('parse');

Parse.initialize("ubug-parse");

Parse.serverURL = 'https://parse.ubug.io/parse'

export async function collectView(attr = 'views') {
  const pathName = window.location.pathname.replace(/\/$/, '')

  const BlogCounter = Parse.Object.extend("blog_counter");
  const query = new Parse.Query(BlogCounter);

  query.equalTo("blog", pathName);
  let object = await query.first();
  if (object) {
    object.increment(attr);
    await object.save();
  } else {
    const blogCounter = new BlogCounter();
    blogCounter.set(attr, 1);
    blogCounter.set("blog", pathName);
    object = await blogCounter.save();
  }
  console.log(`--> ${pathName} 已统计`, object.attributes.views)
  return object
}

export async function fetchReadingList(limit = 10) {
  const RecentReading = Parse.Object.extend("recent_reading");
  const query = new Parse.Query(RecentReading);

  let results = await query.descending("time").limit(limit).find();
  if (results) {
    console.log(results)
    return results
  }
  return []
}
